import React from 'react';
import ReactDom from 'react-dom';

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import {deepBind} from 'base-contentmodel';

import BaseComponent from 'base-component';
import BaseContentModel from 'base-contentmodel';

import ExampleComponent from './component';

export class ExampleSubContentModel extends BaseContentModel{
  static _slots = {
    text: "",    
    richText: "RichText"
  }
  /* @slot */ @observable 
  text = "Default text"

  /* @slot("RichText") */ @observable 
  richText = "Default text for richText"  

  @observable @deepBind 
  userInput = {
    get variable(){ return `G:${this.id}_userInput:G`; },
    defaultValue: "another default"
  }

}

export class ExampleContentModel extends BaseContentModel{
  // the ContentModel classes contain the customizable "slots" that content creators will be filling in
  // presently these are defined via static _slots, but will be applied via @slot sugar
  // see the list below for examples of the slot types, and the editor input created for each:
  static _slots = {    
    textSlot: "", // textarea
    richTextSlot: "RichText", // trix wysiwyg
    textOptionsSlot: "", // see _options
    numberSlot: 0, // text input, coerced to number
    booleanSlot: false, // checkbox
    referenceSlot: ExampleSubContentModel, // data-editable, contentModel mode
    referenceArraySlot: [ExampleSubContentModel] // data-editable, arrayAccessor mode
  }
  // options are a way to supply slots with specific options
  // this is currently defined manually, but will be taken care of by @options decorator 
  @observable @deepBind _options = {
    get textOptionsSlot(){ // turns textOptionsSlot into dropdown
      return ["Option1", "Option2", "Option3"];
    }
  }
  // define the default Component (Sim) view of this component
  Component = ExampleComponent

  // below is what content model definitions will ultimately look like. note the commented out decorators.
  // when these are in place, you will not need @observable, @observable.ref, etc
  @observable 
  /* @slot */ textSlot = ""

  @observable 
  /* @slot("RichText") */ richTextSlot = ""

  @observable 
  /* @options(["Option1", "Option2", "Option3"]) @slot */ textOptionsSlot = ""

  @observable 
  /* @slot */ numberSlot = 0

  @observable 
  /* @slot */ booleanSlot = false

  @observable.ref
  /* @slot(ExampleSubContentModel) */ referenceSlot = null

  @observable.shallow
  /* @slot([ExampleSubContentModel]) */ referenceArraySlot = []


  @observable @deepBind 
  isCompleted = {
    get variable(){ return `G:${this.id}_isCompleted:G`; },
    defaultValue: false
  }

  // @input userInput = 100
  // creates...

  @observable @deepBind 
  userInput = {
    get variable(){ return `G:${this.id}_userInput:G`; },
    defaultValue: 100,
    value: ""
  }

  // @input.computed userInput_computed = () => {
    // const userInput2Val = this.$inputStore.getInput(this, "userInput2")
    // return userInput2Val + " was computed ... "
  // }
  // creates...

  @observable @deepBind 
  userInput_computed = {
    get variable(){ return `G:${this.id}_userInput_computed:G`; },
    get value(){ 
      if(!this.$inputStore) return ""
      const userInputVal = this.$inputStore.getInput(this, "userInput")
      return userInputVal + " was computed! (also gets saved, but is computed on UI), saves to variable: " + this["userInput_computed"].variable
    }
  }

  // @input( () => `G:${this.id}_customVarName123:G` ) customUserInput = () => this.textOptionsSlot
  // creates...

  @observable @deepBind 
  customUserInput = {
    get variable(){ return `G:${this.id}_customVarName123:G`; },
    get defaultValue(){ return this.textOptionsSlot },
    value: ""
  }

}
export default ExampleContentModel


// WEBPACK FOOTER //
// ./app_modules/example-activity/contentmodel.js